module.exports = __webpack_public_path__ + "img/shape_parallelogram.94d6a424.svg";